import videojs from 'video.js';

const utils = {
    _custom_css: {},
    loadCss(css_url, callback) {
        if (this._custom_css[css_url]) {
            callback && callback();
            return;
        }
        var head = document.getElementsByTagName('head')[0];
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = css_url;
        link.media = 'all';

        if (callback) {
            var loaded = false;
            var webkitLoadCheck = function() {
                setTimeout(function() {
                    if (loaded) return;
                    for (var i = 0; i < document.styleSheets.length; i++) {
                        var sheet = document.styleSheets[i];
                        if (sheet.href == link.href) {
                            loaded = true;
                            return callback();
                        }
                    }
                    webkitLoadCheck();
                }, 10);
            };
            webkitLoadCheck();
            link.onload = function() {
                if (loaded) return;
                loaded = true;
                callback();
            };
        }
        head.appendChild(link);

        this._custom_css[css_url] = 1;
    }
};

export default utils;